<template>
  <div>
    <UserDialog
      v-model="isDialogOpen"
      :mode="'CREATE'"
      :title="'Neuen Nutzer anlegen'"
      :dialog-content="''"
      :button="'anlegen'"
      @fetchUsers="fetchUsers()"
    ></UserDialog>
    <UserDialog
      v-model="isUserUpdateDialogOpen"
      :mode="'UPDATE'"
      :user-update-id="userUpdateId"
      :title="'Nutzer bearbeiten'"
      :dialog-content="''"
      :button="'Bearbeiten'"
      @fetchUsers="fetchUsers()"
    ></UserDialog>
    <ConfirmationDialog
      v-model="isUserDeletionDialogOpen"
      :title="'Nutzer löschen'"
      :dialog-content="'Möchten Sie diesen Nutzer wirklich löschen?'"
      :button="'Löschen'"
      @confirmed="deleteUser"
    ></ConfirmationDialog>
    <v-row cols="12">
      <v-col cols="6" sm="6">
        <v-autocomplete
          v-model="selectedUser"
          :items="userSelection"
          :label="`Nutzersuche`"
          persistent-hint
          prepend-icon="mdi-magnify"
          @change="filterUser()"
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="3" sm="3"> </v-col>
      <v-col cols="3" sm="3">
        <v-btn
          class="text-center mt-2 ml-4 justify-end"
          color="primary"
          @click="openCreateUserDialog()"
        >
          {{ $cmsService.getContent(content, 'create_user') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Datensätze pro Seite',
        'items-per-page-all-text': 'Alle',
        'page-text': '{0}-{1} von {2}'
      }"
      :headers="headers"
      :items="displayedUsers"
      :items-per-page="10"
      class="elevation-1"
      :height="500"
    >
      <template #[`item.firstName`]="{ item }">
        <span>{{ item.firstName }}</span>
      </template>
      <template #[`item.lastName`]="{ item }">
        <span>{{ item.lastName }}</span>
      </template>
      <template #[`item.email`]="{ item }">
        <span>{{ item.email }}</span>
      </template>
      <template #[`item.actions`]="{ item }">
        <v-menu bottom left class="secondary--text">
          <template #activator="{ on }">
            <v-btn
              name="actions"
              depressed
              tile
              small
              color="white"
              width="35"
              min-width="0"
              v-on="on"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item name="edit" @click="openUpdateUserDialog(item.id)">{{
              $cmsService.getContent(content, 'update_user')
            }}</v-list-item>
            <v-list-item
              color="error"
              name="delete"
              @click="openUserDeletionDialog(item.id)"
            >
              {{ $cmsService.getContent(content, 'delete') }}</v-list-item
            >
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import UserDialog from '@/components/dialogs/UserDialog'
import ConfirmationDialog from '@/components/dialogs/ConfirmationDialog'
import userJson from '@/data/json/tables/user.json'
import { userService } from '@/services'

export default {
  components: {
    UserDialog,
    ConfirmationDialog
  },
  data: () => ({
    content: userJson.data,
    isDialogOpen: false,
    isUserDeletionDialogOpen: false,
    isUserUpdateDialogOpen: false,
    isErrorDialogOpen: false,
    selectedUser: '',
    userSelection: [],
    fetchedUsers: [],
    displayedUsers: [],
    userDeletionId: null,
    userUpdateId: null
  }),
  created: function() {
    // argument is cms api-endpoint
    this.generateHeaders()
    this.fetchUsers()
  },
  methods: {
    generateHeaders() {
      this.headers = [
        {
          text: 'E-Mail',
          value: 'email',
          sortable: true
        },
        {
          text: 'Vorname',
          value: 'firstName',
          sortable: false
        },
        {
          text: 'Nachname',
          value: 'lastName',
          sortable: true
        },
        {
          text: 'Aktionen',
          value: 'actions',
          sortable: false,
          align: 'center',
          width: 150
        }
      ]
    },
    fetchUsers() {
      userService.getUsers().then(users => {
        this.fetchedUsers = users
        this.displayedUsers = this.fetchedUsers
        this.userSelection = this.getUserSelection()
      })
    },
    filterUser: function() {
      if (this.selectedUser == '' || this.selectedUser == 'alle') {
        this.displayedUsers = this.fetchedUsers
      } else {
        this.displayedUsers = this.fetchedUsers.filter(
          element => element.email == this.selectedUser
        )
      }
    },
    getUserSelection: function() {
      const nameArray = []
      nameArray.push('alle')
      this.fetchedUsers.forEach(element => {
        nameArray.push(element.email)
      })
      return nameArray
    },
    deleteUser: function() {
      userService.deleteUser(this.userDeletionId).then(() => {
        this.fetchUsers()
        this.isUserDeletionDialogOpen = false
      })
    },
    openUserDeletionDialog: function(id) {
      this.userDeletionId = id
      this.isUserDeletionDialogOpen = true
    },
    openCreateUserDialog: function() {
      this.isDialogOpen = true
    },
    openUpdateUserDialog: function(id) {
      this.userUpdateId = id
      this.isUserUpdateDialogOpen = true
    }
  }
}
</script>
